export const environment = {
  production: false,
  backendUrl: '/api',
  socketUrl: '',
  version: '2026.09.03',
  mfaRequired: false,
};
